export default {
    methods: {
        retirarMenos(event) {
            return event.key === '-' && event.preventDefault()
          },
    }
}